import styled, { css } from 'styled-components';

import { media } from '@theme/media';

export const Container = styled.div``;

export const Title = styled.div`
  font-size: 14px;
  line-height: 1.4em;
  letter-spacing: 0.02em;
  font-weight: 500;
  text-transform: uppercase;
  text-align: center;
  margin: 102px 0;
`;

export const ProductsContainer = styled.div`
  margin: 0;
  padding: 0 24px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr 1fr;

  ${media.mobile} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${media.tablet} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const imageStyles = css`
  height: calc(50vw - 40px);
  object-fit: contain;
  max-width: 100%;

  ${media.tablet} {
    height: calc(25vw - 40px - 15px);
  }
`;
